import { render } from "./BlogPostList.vue?vue&type=template&id=1f60bbd2"
import script from "./BlogPostList.vue?vue&type=script&lang=js"
export * from "./BlogPostList.vue?vue&type=script&lang=js"

import "./BlogPostList.vue?vue&type=style&index=0&id=1f60bbd2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__